import type { StayTicketType } from "../../../../__generated__/gql/graphql";

/**
 * 新しい部屋タイプ予約体験(NewExperience)を出すかの唯一の判定シーム。
 * 段階公開/ロールバックはこの関数の中身だけを書き換える。
 * 現状: Regular チケットの新規予約に一般公開している。
 */
export function shouldUseNewRoomTypeExperience(args: {
  reservationType: StayTicketType;
  originalReservationData: object | null;
}): boolean {
  const { reservationType, originalReservationData } = args;
  return reservationType === "Regular" && originalReservationData === null;
}
